import React, { Component } from 'react'
import Link from '../../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

class SuburbCard extends Component {

  render() {

    const { title, slug, acf } = this.props

    return (
      <div className='property-option property-option--suburb'>
        <img className='property-option__image' loading='lazy' src={acf.mobileImage?.sourceUrl} alt={title} />
        <span className='property-option__view'>View</span>
        { acf.mainStat?.value && acf.mainStat?.label &&
          <div className='property-option__main-stat'>
            <span className='value'>{acf.mainStat.value}</span>
            <span className='label'>{acf.mainStat.label}</span>
          </div>
        }
        <div className='property-option__details'>
          <p className='title'>{ title }</p>
          <div className='copy' dangerouslySetInnerHTML={{ __html: acf.snippet }} />
        </div>
        <Link className='property-option__link' to={`/suburb/${slug}/`}></Link>
      </div>
    )
  }
}

export default SuburbCard